import { render, staticRenderFns } from "./DatasetEditor.vue?vue&type=template&id=d4438c30&scoped=true"
import script from "./DatasetEditor.vue?vue&type=script&lang=js"
export * from "./DatasetEditor.vue?vue&type=script&lang=js"
import style0 from "./DatasetEditor.vue?vue&type=style&index=0&id=d4438c30&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4438c30",
  null
  
)

export default component.exports